 import CallBack from './Components/Login/CallBack';

function App() {
   return (
    <CallBack/>
  );
}

export default App;
